import "./logTable.css";
import * as React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Autocomplete,
  TablePagination,
  TextField,
  Button,
  IconButton
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import LogPlotDialog from "../LineCharts/LogPlotDialog";
import RawDeleteDialog from './RawDeleteDialog';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const LogTable = ({ tableName, reloadEvent, auth, onLogout }) => {

    const categories = [
    { label: "Drift" },
    { label: "Membrane_test" },
    { label: "CorrugatA" },
    { label: "oil_a" },
    { label: "Tempbox" },
  ];

  const [tableData, setTableData] = React.useState([]);
  const [selectedTableId, setSelectedTableId] = React.useState(null);
  const [selectedCategory, setSelectedCategory] = React.useState(categories[3].label);

  // Function to fetch data from the server
  const fetchData = React.useCallback(async () => {
    // console.log("Fetching Table details with category:", selectedCategory);
    // console.log("auth: ", auth);
    try {
      const response = await fetch(`${API_BASE_URL}/rawdata/master-table-data?category=${selectedCategory}`, {
        headers: { Authorization: `Bearer ${auth.token}` }
      });
      if (response.status === 401) {
        onLogout(); // Trigger logout on 401 Unauthorized
        return;
      }
      const data = await response.json();
      // console.log("Fetched data:", data);
      setTableData(data);
    } catch (error) {
      // console.error("Error fetching data:", error);
      if (error.response?.status === 401) {
        onLogout(); // Trigger logout on 401 Unauthorized
      }
    }
  });

  React.useEffect(() => {
    if (auth.isAuthenticated) {
      fetchData();
    }
  }, [tableName, reloadEvent, selectedCategory]);

  // console.log("Table Data:", tableData?.data);

  // Extract the first row to get the fields dynamically
  let TableData = tableData?.data || [];
  let tempData = TableData[0] || {};
  let fields = Object.keys(tempData);
  const dynamicFields = [];
  for (let i = 0; i < fields.length; i++) {
    let dynamicField = {}
    dynamicField.id = fields[i];
    dynamicField.label = fields[i];
    dynamicField.minWidth = 100;
    dynamicFields.push(dynamicField);
  }

  // Add the action column
  dynamicFields.push({
  id: "action",
  label: "Actions",
  minWidth: 100,
  });



  // 1. Extract unique Table_id values
  const tableIdOptions = Array.from(
    new Set(TableData.map(row => row.Table_id).filter(Boolean))
  );
  // 2. Filter TableData by selected Table_id
  const filteredTableData = selectedTableId
    ? TableData.filter(row => row.Table_id === selectedTableId)
    : TableData;

  // Add dialog state for plotting
  const [plotDialogOpen, setPlotDialogOpen] = React.useState(false);
  const [selectedTableIdForPlot, setSelectedTableIdForPlot] = React.useState(null);

  //Add dialog state for deleting rows
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
  const [selectedTableIdForDelete, setSelectedTableIdForDelete] = React.useState(null);
  const [selectedCategoryForDelete, setSelectedCategoryForDelete] = React.useState(null);

  const columns = dynamicFields;

  // pagination
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // Function to handle category change
  const handleCategoryChange = (event, value) => {
    if (value) {
      // console.log("Selected category:", value.label);
      setSelectedCategory(value.label);
      fetchData()
    }

  }

  return (
    <>
    <Grid container spacing={2} className="container" justifyContent="center">
      <Grid size={{ xs: 12, md:20 }}>
          <div className="filter">
            {/* 3. Add Autocomplete for Table_id filter */}
            <Autocomplete
              options={tableIdOptions}
              value={selectedTableId}
              onChange={(e, value) => setSelectedTableId(value)}
              renderInput={(params) => (
                <TextField {...params} label="Filter by Table_id" size="small" />
              )}
              sx={{ width: 300}}
              clearOnEscape
            />
            {/* Add Autocomplete for categories filter to select by type of test */}
            <Autocomplete
              options={categories}
              defaultValue={categories[3]}
              renderInput={(params) => (
                <TextField {...params} label="Category" size="small"/>
                    )}
              sx={{ width: 300}}
              clearOnEscape
              onChange={handleCategoryChange}
              />
          </div>
        <Paper
          sx={{ width: "100%", overflow: "hidden", bgcolor: "#E3F2FD" }}
          elevation={15}
        >
          <TableContainer sx={{ maxHeight: 900 }}>
            <Table stickyHeader aria-label="dynamic sensor table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      className="table-head-cell"
                      key={column.id}
                      align={column.align || "left"}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredTableData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, rowIndex) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={rowIndex}>
                        {columns.map((column) => {
                          if (column.id === "action") {
                                      return (
                                        <TableCell key={column.id} align={column.align || "left"}>
                                        <div className="action-buttons">
                                          <Button
                                          variant="contained"
                                          size="small"
                                           onClick={() => {
                                            setSelectedTableIdForPlot(row.Table_id)
                                            setSelectedCategory(row.Category)
                                            setPlotDialogOpen(true)

                                           }}>
                                            PLOT
                                          </Button>
                                          <IconButton
                                            aria-label="delete"
                                            size="medium"
                                            onClick={() => {
                                              setSelectedTableIdForDelete(row.Table_id)
                                              setSelectedCategoryForDelete(row.Category)
                                              setDeleteDialogOpen(true);
                                            }}
                                          >
                                            <DeleteIcon fontSize="medium" color="error" />
                                          </IconButton>
                                          </div>
                                        </TableCell>

                                      );
                            }
                            if (column.id === "category") {
                                      return (
                                        <TableCell key={column.id} align={column.align || "left"}>
                                          {row.category || "-"}
                                        </TableCell>

                                      );
                            }
                          const value = row[column.id];
                          return (
                            <TableCell key={column.id} align={column.align || "left"}>
                              {column.format && typeof value === "number"
                                ? column.format(value)
                                : value || "-"}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100, 200, 500]}
              component="div"
              count={TableData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Paper>
      </Grid>
    </Grid>
    <LogPlotDialog open={plotDialogOpen} onClose={() => setPlotDialogOpen(false)} tableId={selectedTableIdForPlot} category={selectedCategory} auth={auth} onLogout={onLogout}/>
    <RawDeleteDialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} tableId={selectedTableIdForDelete} category={selectedCategoryForDelete} auth={auth} onLogout={onLogout}/>
    </>
  );
};

export default LogTable;